import {
  GETMANUALUPGRADEKYCLIST_SUCCESS,
  GETMANUALUPGRADEKYCLIST_FAILED,
  RESET_GETMANUALUPGRADEKYCLIST,
  LOADING_GETMANUALUPGRADEKYCLIST,
  NETWORK_ERROR_GETMANUALUPGRADEKYCLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETMANUALUPGRADEKYCLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETMANUALUPGRADEKYCLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETMANUALUPGRADEKYCLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETMANUALUPGRADEKYCLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETMANUALUPGRADEKYCLIST:
      return (state = initialState);
    default:
      return state;
  }
};
